const obj = {
  new_york: 'America/New_York',
  london: 'Europe/London',
};

export default obj;
